import { render, staticRenderFns } from "./PrettyWaypointLink.vue?vue&type=template&id=823ef872&scoped=true"
import script from "./PrettyWaypointLink.vue?vue&type=script&lang=js"
export * from "./PrettyWaypointLink.vue?vue&type=script&lang=js"
import style0 from "./PrettyWaypointLink.vue?vue&type=style&index=0&id=823ef872&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823ef872",
  null
  
)

export default component.exports